import React, { useState, useEffect } from 'react';
import './headerStyle.css'
import { useNavigate } from "react-router-dom";
import Box from '@mui/joy/Box';
import Drawer from '@mui/joy/Drawer';
import DialogTitle from '@mui/joy/DialogTitle';
import ModalClose from '@mui/joy/ModalClose';
import { Divider, List, ListItem, ListItemButton } from '@mui/joy';


const LandingHeaderComponent = () => {

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDemoGraphicsScrolled, setIsDemoGraphicsScrolled] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      if(window.scrollY > 100 && window.scrollY<700){
        setIsDemoGraphicsScrolled(true);
      } else{
        setIsDemoGraphicsScrolled(false);
      }
      if ((window.scrollY > 700 && window.scrollY<1450) || window.scrollY > 2200 ) {
        setScrolled(true);
      } else {
        setScrolled(false)
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

 // Function to handle smooth scrolling
 const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
      window.scrollTo({
          top: section.offsetTop,
          behavior: 'smooth' // Make the scrolling smooth
      });
  }
};
  return (
    <div className={`header ${scrolled ? 'visible' : ''}`} id="header">
      <div className={`whole-background-header-wrap ${scrolled ? 'visible' : ''} ${isDemoGraphicsScrolled ? 'demographics-visible' : ''}`}>
        <div className="main-container">
            <div className="header-blocks">
                <div className="header-block-1" onClick={()=>{navigate('/')}}>BOSS</div>
                <div className="header-block-2">
                  <div className="header-action-button" onClick={() => scrollToSection('bossMagicSection')}>Boss Magic</div>
                  <div className="header-action-button" onClick={() => scrollToSection('keyFeaturesSection')}>Key Features</div>
                  <div className="header-action-button" onClick={() => scrollToSection('pricingSection')}>Pricing</div>
                  <div className="header-action-button" onClick={() => scrollToSection('contactusSection')}>Contact us</div>
                  <div className="book-demo-action-button" onClick={() => scrollToSection('bossMagicSection')}>Book a Demo</div>
                  <div className="login-actn-btn" onClick={()=>{navigate('/login')}}>Login/Register</div>


          
                </div>

                <div className="header-block-3" onClick={() => setOpen(true)}>
                  <div className={`handburgericon ${scrolled ? 'visible' : ''}`}></div>
                  <div className={`handburgericon ${scrolled ? 'visible' : ''}`}></div>
                  <div className={`handburgericon ${scrolled ? 'visible' : ''}`}></div>
                </div>

                
                <Drawer
                    color="neutral"
                    invertedColors                      
                    size="md"
                      variant="soft"
                      open={open} onClose={() => setOpen(false)}
                      sx={{
                        '--Drawer-transitionDuration': open ? '0.4s' : '0.2s',
                        '--Drawer-transitionFunction': open
                          ? 'cubic-bezier(0.79,0.14,0.15,0.86)'
                          : 'cubic-bezier(0.77,0,0.18,1)',
                      }}
                    >  <ModalClose />
                    <DialogTitle>M2R2 - Boss</DialogTitle>
                    <Divider />
                      <Box role="presentation" sx={{ p: 2 }}>
                        <List>
                      <ListItem key="text">
                      <ListItemButton onClick={() => scrollToSection('bossMagicSection')}>Boss Magic Section</ListItemButton>
                      </ListItem>
                     
            
                      <ListItem key="text">
                        <ListItemButton onClick={() => scrollToSection('keyFeaturesSection')}>Key features</ListItemButton>
                      </ListItem>
                      <ListItem key="text">
                        <ListItemButton onClick={() => scrollToSection('pricingSection')}>Pricing</ListItemButton>
                      </ListItem>
                      <ListItem key="text">
                        <ListItemButton onClick={() => scrollToSection('contactusSection')}>Contact us</ListItemButton>
                      </ListItem>
                      <ListItem key="text">
                        <ListItemButton onClick={() => scrollToSection('bossMagicSection')}>Book a Demo</ListItemButton>
                      </ListItem>
                      </List><Divider />
                      <List>
                      <ListItem key="text">
                        <ListItemButton  onClick={()=>{navigate('/login')}}>Login/Register</ListItemButton>
                      </ListItem>
                     
                      </List>
                 
                  
               
                  
               </Box>
                  
                  </Drawer>

                
                </div>
            </div>
        </div></div>
  )
}

export default LandingHeaderComponent